import { Pipe , PipeTransform } from '@angular/core'

@Pipe({
		name: 'formatRisk'
})
export class FormatRisk implements PipeTransform {
		public transform(value: string): string {
				if (value.toLocaleLowerCase() == 'muito_alto') {
						return 'Muito alto'
				} else {
						return `${value[0].toUpperCase() + value.substring(1).toLowerCase()}`
				}
		}
}
